function NurseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      fill="none"
      viewBox="0 0 49 54"
    >
      <path d="M47.667 39.255l-4.714-13.422c-.914-2.53-2.67-4.505-7.627-4.505H13.562c-4.955 0-6.714 1.975-7.625 4.505L1.225 39.255c-.353.867-.535 2.815 1.383 4.12l11.082 7.302a3.516 3.516 0 004.866-.992 3.51 3.51 0 00-1-4.864L8.76 39.024l2.475-6.83h3.427l-2.007 5.54 6.678 4.402a6.672 6.672 0 012.885 4.263 6.68 6.68 0 01-.97 5.06A6.752 6.752 0 0119.821 53h9.247a6.88 6.88 0 01-1.427-1.54 6.693 6.693 0 01-.973-5.06 6.69 6.69 0 012.886-4.263l6.682-4.401-2.015-5.54h3.43l2.48 6.829-8.8 5.797a3.511 3.511 0 00-.998 4.864 3.517 3.517 0 004.867.992l11.08-7.302c1.92-1.306 1.739-3.253 1.388-4.12h-.002zM26.61 8.192a3.312 3.312 0 01-3.007 1.926 3.32 3.32 0 01-3.014-1.926h-6.071a9.027 9.027 0 00-.156 1.641c0 5.116 4.153 9.262 9.273 9.262 5.124 0 9.274-4.147 9.274-9.262 0-.563-.06-1.108-.154-1.64H26.61zM20.384 6.005a3.322 3.322 0 013.22-2.507 3.313 3.313 0 013.213 2.507h5.26C30.617 2.802 27.392.57 23.637.57a9.274 9.274 0 00-8.44 5.436h5.188-.001z"></path>
    </svg>
  );
}

export default NurseIcon;
